import AssignVehicles from "./AssignVehicles";
export default AssignVehicles;



